import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Machine } from "@interfaces/models/machine.interface";
import { Service } from "@services/service";
import { Guid } from "guid-typescript";

@Injectable()
export class ToolroomProcessMachineService extends Service {
	constructor(injector: Injector) {
		super("ToolroomProcessMachine", injector);
	}

	// API
	forMachine(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForMachine/${id}`);
	}

	forToolroomProcess(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForToolroomProcess/${id}`);
	}

	updateMachinesForToolroomProcess(lookupId: Guid, data: Machine[]) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/UpdateMachinesForToolroomProcess/${lookupId}`, data);
	}
}
